<script setup lang="ts">
import { ref, inject } from "vue";
import { VServices } from "@libVue/base";
import { TranslationService } from "../services/translation.service";
import { GoogleMap, AdvancedMarker, InfoWindow } from "vue3-google-map";

const t = (inject<TranslationService>("translationSvc") as TranslationService)
    .t;

const { apiKey, mapId } = defineProps({
    apiKey: {
        type: String,
        required: true,
    },
    mapId: {
        type: String,
        required: true,
    },
});

const center = ref({ lat: 47.541091, lng: 7.614202 });

const options = ref({ position: center, title: "Chemie Brunschwig AG" });
const pinOptions = ref({});
</script>

<template>
    <div>
        <google-map
            :api-key="apiKey"
            :mapId="mapId"
            style="width: 100%; height: 500px"
            :center="center"
            :zoom="14"
        >
            <advanced-marker :options="options" :pin-options="pinOptions">
            </advanced-marker>
            <InfoWindow
                :options="{
                    position: center,
                    pixelOffset: { width: 0, height: -40 },
                }"
            >
                Chemie Brunschwig AG<br />
                Auf dem Wolf 10<br />
                CH-4052 Basel<br />
            </InfoWindow>
        </google-map>
    </div>
</template>
